export default "__VITE_ASSET__CxjQ21RV__"